export default __webpack_public_path__ + "static/media/logo-determined-on-dark-horizontal.1e2026ad.svg";